Vue.use(Router);

import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '../Layouts/mainLayout'

import HomePage from '../Pages/HomePage'
import Develteam from '../Pages/Develteam'
import Boomerang2D from '../Pages/Boomerang2D'
import InfiniteHyrule from "../Pages/InfiniteHyrule";
import GaneshaDX from "../Pages/GaneshaDX";
import SlideyBlocks from "../Pages/SlideyBlocks";
import FFTMaps from "../Pages/FFTMaps";
import NSMBMaps from "../Pages/NSMBMaps";
import GalaxyMaps from "../Pages/GalaxyMaps";
import WriteUps from "../Pages/WriteUps";

export default new Router({
    routes: [
        {
            path: '',
            component: MainLayout,
            children: [
                {
                    path: '/Develteam',
                    component: Develteam
                },
                {
                    path: '/Boomerang2D',
                    component: Boomerang2D
                },
                {
                    path: '/InfiniteHyrule',
                    component: InfiniteHyrule
                },
                {
                    path: '/GaneshaDX',
                    component: GaneshaDX
                },
                {
                    path: '/SlideyBlocks',
                    component: SlideyBlocks
                },
                {
                    path: '/FFTMaps',
                    component: FFTMaps
                },
                {
                    path: '/NSMBMaps',
                    component: NSMBMaps
                },
                {
                    path: '/MarioGalaxyMapRenders',
                    component: GalaxyMaps
                },
                {
                    path: '/WriteUps',
                    component: WriteUps
                },
                {
                    path: '*',
                    component: HomePage,
                    meta: {subNavRoute: 'ListOfProjects'}
                },
            ]
        }
    ],
    mode: 'history'
})
